import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { NavigationService } from '../services/navigation.service';
import { AuthService } from '../services/auth.service';
import { SESSION_KEY, SessionService } from '../services';

export const AuthGuard: CanActivateFn = (route, state): Observable<boolean> | boolean | UrlTree => {
  const navigationService = inject(NavigationService);
  const sessionService = inject(SessionService);
  const authService = inject(AuthService);
  const otp = sessionService.getData(SESSION_KEY.OTP_LOGIN);

  const authReturnUrl = route.data['authReturnUrl'];
  const authStrapiUid = route.data['authStrapiUid'];

  if (!authService.isAuthenticated() && !otp?.otpLoggedIn) {
    navigationService.toAuthentication(authReturnUrl || state.url, authStrapiUid);
    return false;
  }

  return true;
};
